import { defaultHttpClient } from '../../httpClient';
import type { GoodsDetailResponse } from './types';

export const getGoodsDetail = (
  goodsId: number,
  fixedCouponSno?: number,
) => {
  return defaultHttpClient
    .request<GoodsDetailResponse>({
      method: 'GET',
      url: `/api/v3/goods/${goodsId}/detail/`,
      params: fixedCouponSno
        ? { fixed_coupon_sno: fixedCouponSno }
        : undefined,
    })
    .then(result => result.data);
};
